import React from 'react';
import PropTypes from 'prop-types';
import 'react-device-frameset/styles/marvel-devices.min.css';
import AppPreview from './app_preview';
import { formatLongDateInLocale } from '../../services/dates';
import MyDayWelcomeCard from '../shared_programmes/ my_day_welcome_card';
import { userCountryCode } from '../../services/users';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const AppThemePreview = ({
  primaryMainColor,
  backgroundStyle,
  backgroundColor,
  backgroundGradientColor,
  primaryFontColor,
  navBarFontColor,
  spaceTitle,
  myDayBackgroundImageUrl,
  cardBackgroundColor,
}) => {
  const { data: userProfile } = useGetUserProfileQuery();

  const countryCode = userCountryCode(userProfile);

  return (
    <AppPreview
      primaryMainColor={primaryMainColor}
      backgroundStyle={backgroundStyle}
      backgroundColor={backgroundColor}
      backgroundGradientColor={backgroundGradientColor}
      primaryFontColor={primaryFontColor}
      navBarFontColor={navBarFontColor}
      innerContent={
        <>
          <div
            className="screen-title"
            style={{ flexGrow: 1, paddingTop: 64, color: primaryFontColor }}>
            My Day
          </div>
          <div className="screen-subtitle" style={{ color: primaryFontColor }}>
            {formatLongDateInLocale(new Date(), countryCode)}
          </div>
          <div
            style={{
              height: '210px',
              backgroundImage: `url("${myDayBackgroundImageUrl}")`,
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat',
            }}>
            &nbsp;
          </div>
          <MyDayWelcomeCard
            spaceTitle={spaceTitle}
            primaryMainColor={primaryMainColor}
            cardBackgroundColor={cardBackgroundColor}
          />
        </>
      }
    />
  );
};

AppThemePreview.propTypes = {
  primaryMainColor: PropTypes.string,
  backgroundStyle: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundGradientColor: PropTypes.string,
  primaryFontColor: PropTypes.string,
  navBarFontColor: PropTypes.string,
  spaceTitle: PropTypes.string,
  myDayBackgroundImageUrl: PropTypes.string,
  cardBackgroundColor: PropTypes.string,
};

AppThemePreview.defaultProps = {
  primaryMainColor: null,
  backgroundStyle: 'SOLID',
  backgroundColor: null,
  backgroundGradientColor: null,
  primaryFontColor: null,
  navBarFontColor: null,
  spaceTitle: null,
  myDayBackgroundImageUrl: null,
  cardBackgroundColor: null,
};

export default AppThemePreview;
